/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 363c7ad4fafa
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";
import { ApiError, ApiError$zodSchema } from "./apierror.js";

export type DownloadBackupAssetGlobals = { cloud_name?: string | undefined };

export const DownloadBackupAssetGlobals$zodSchema: z.ZodType<
  DownloadBackupAssetGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type DownloadBackupAssetRequest = {
  asset_id: string;
  version_id: string;
};

export const DownloadBackupAssetRequest$zodSchema: z.ZodType<
  DownloadBackupAssetRequest
> = z.object({
  asset_id: z.string().describe(
    "The asset ID of the resource. Must be a 32-character hexadecimal string.",
  ),
  version_id: z.string().describe(
    "The version ID of the backup to download. Must be a 32-character hexadecimal string.",
  ),
});

export type DownloadBackupAssetResponse =
  | ApiError
  | Uint8Array
  | string
  | Uint8Array
  | string
  | Uint8Array
  | string
  | Uint8Array
  | string;

export const DownloadBackupAssetResponse$zodSchema: z.ZodType<
  DownloadBackupAssetResponse
> = z.union([
  ApiError$zodSchema,
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
]);
